import { useEffect, useState } from 'react'

const useIsOfficeAddin = () => {
  const [isInPowerPoint, setIsInPowerPoint] = useState(false)

  useEffect(() => {
    if (window.Office) {
      Office.onReady(({ host }) => setIsInPowerPoint(host === Office.HostType.PowerPoint))
    } else {
      console.warn('Office.js not loaded.')
    }
  }, [])

  return isInPowerPoint
}

export default useIsOfficeAddin
